import React from 'react'
import { dayjs } from '@mobi/utils/date'
import { Day } from './Components/Day'
import { Night } from './Components/Night'
import { GreetingLabelStyled, GreetingContainer } from './Greeting.styles'

export const Greeting = () => {
  const currHour = dayjs().hour()
  return (
    <GreetingContainer>
      {currHour > 5 && currHour < 18 ? <Day /> : <Night />}
      <GreetingLabelStyled>
        {'Good ' + ((currHour < 12 && 'morning') || (currHour < 18 && 'afternoon') || 'evening')}
      </GreetingLabelStyled>
    </GreetingContainer>
  )
}
